import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyCategory } from '../company/company-category.model';
import { CompanyOwned } from '../company/company-models.model';
import { ElementGroupCode } from './element-group-code.model';

@HateoasResource('elementcode')
export class ElementCode extends CompanyOwned {
  public categorie: CompanyCategory | undefined | null;
  public code: string | undefined;
  public eenheid: string | undefined;
  public groep: string | undefined;
  public naam!: string;
  public nlsfb: string | undefined;
  public verborgen: boolean | undefined;
  public hvh!: number;
  public laag!: string;
  public stabu!: string;
  public vrijecode!: string;
  public master: string | undefined;

  //FRONTEND ONLY
  public index!: number;
  public fullNaam!: string;
  public groepNaam!: string;
  public groepResolved: ElementGroupCode | undefined;
  public elementGroupCode?: ElementGroupCode;
}
